/**
 * @generated SignedSource<<41cbeaa06d5991b406f8cd5c92a2f482>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1

import type { ConcreteRequest } from 'relay-runtime';
export type ObjectAddCommentProfileWrapperUserQuery$variables = {
  id: string;
};
export type ObjectAddCommentProfileWrapperUserQuery$data = {
  readonly user: {
    readonly displayName: string | null;
    readonly id: string | null;
    readonly photos: ReadonlyArray<{
      readonly value: string | null;
    } | null> | null;
  } | null;
};
export type ObjectAddCommentProfileWrapperUserQuery = {
  response: ObjectAddCommentProfileWrapperUserQuery$data;
  variables: ObjectAddCommentProfileWrapperUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ObjectAddCommentProfileWrapperUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectAddCommentProfileWrapperUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0725da37403499b17b096784b15edae6",
    "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
    "metadata": {},
    "name": "ObjectAddCommentProfileWrapperUserQuery",
    "operationKind": "query",
    "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
  }
};
})();

(node as any).hash = "d4c2e7d15525539be1b21ee5306d9088";

export default node;
